import * as Footer from './Footer';
import { Main, type MainProps } from './Main';
import * as Navigation from './Navigation';
import { Root, type RootProps } from './Root';
import { Section, type SectionProps } from './Section';
import { SectionContent, type SectionContentProps } from './SectionContent';

export {
  Root,
  type RootProps,
  Main,
  type MainProps,
  Section,
  type SectionProps,
  SectionContent,
  type SectionContentProps,
  Navigation,
  Footer,
};
